export default function($form) {
    var $params = $form.getExtForm();
    if (!$form.isValid(true)) {
        return;
    }

    $params.btnDebounce(function() {
        var params = {};
        params.type = 'complete';
        params.taskId = $params.taskId;
        params.formId = $params.formId;
        params.formKey = $params.formKey;
        params.appId = $params.appId;
        params.entityId = $params.entityId;
        if ($params.comment) {
            params['$comment'] = $params.comment;
        }
        var btnName = $params.action;
        $params.setBtnLoading(true, btnName);
        if($params.extParams && $params.extParams.fullAuthType){
          params.fullAuthType = $params.extParams.fullAuthType;
        }
        function doReaded(params) {
            PF.api.process.batchCommit(params).then(res => {
                var data = res.result;
                if (data && !data.success) { //提交意见检查
                    if (data.errorType == 'comment') {
                        if (data.errorCode == 'comment_check_stop') {
                            PF.message('info', $lang('您还没有填写意见,请填写意见!'));
                            $params.setBtnLoading(false, btnName);
                            return;
                        } else if (data.errorCode == 'comment_check_remind') {
                            PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), { type: 'warning' }).then(() => {
                                params['$directSave'] = true;
                                doReaded(params);
                            }).catch(() => {
                                $params.setBtnLoading(false, btnName);
                            });
                            return;
                        }
                    } else {
                        var errorMsg = '';
                        if (data.errorMsg) {
                            errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                        }
                        PF.message('info', $lang('完成失败') + errorMsg + '!');
                        $params.setBtnLoading(false, btnName);
                        return;
                    }
                } else {
                    $params.formActionComplete();
                    $params.setBtnLoading(false, btnName);
                }
            }).catch(() => {
                $params.setBtnLoading(false, btnName);
            });
        }

        doReaded(params);
    });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-readed.js